import React from "react";

const SvgCancel = props => <svg viewBox="0 0 8 8" fill="none" {...props}><path d="M.952.953a.862.862 0 0 0 0 1.219L2.78 4 .952 5.83A.862.862 0 0 0 2.17 7.048l1.828-1.829 1.829 1.829a.862.862 0 1 0 1.219-1.22L5.218 4l1.829-1.828a.862.862 0 1 0-1.22-1.22L4 2.783 2.171.951a.862.862 0 0 0-1.22 0z" fill="#F33" /></svg>;

export default SvgCancel;